import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { VerticalPosterCard, Input } from "@bloom/ui";
import { useLocale } from "../locale/locale-context.tsx";
import { api } from "../api/client.ts";

interface Hit {
  id: string;
  slug: string;
  titleTh: string;
  titleEn: string;
  posterUrl?: string;
}

export function SearchPage() {
  const { locale, t } = useLocale();
  const [params, setParams] = useSearchParams();
  const initialQ = params.get("q") ?? "";
  const [query, setQuery] = useState(initialQ);
  const [hits, setHits] = useState<Hit[]>([]);

  useEffect(() => {
    if (!query) {
      setHits([]);
      return;
    }
    setParams({ q: query }, { replace: true });
    const t = setTimeout(async () => {
      try {
        const data = await api.get<{ hits: Hit[] }>(`/api/search?q=${encodeURIComponent(query)}`);
        setHits(data.hits);
      } catch {
        setHits([]);
      }
    }, 200);
    return () => clearTimeout(t);
  }, [query, setParams]);

  return (
    <div className="mx-auto max-w-6xl space-y-6 px-4 py-8 sm:px-6">
      <h1 className="font-display text-3xl">{t("nav.search")}</h1>
      <Input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={t("nav.search")}
        autoFocus
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-6">
        {hits.map((h) => (
          <VerticalPosterCard
            key={h.id}
            href={`/series/${h.slug}`}
            titleTh={h.titleTh}
            titleEn={h.titleEn}
            posterUrl={h.posterUrl ?? "https://placehold.co/720x1280/F7C8D5/0E0E10.png"}
            locale={locale}
          />
        ))}
      </div>
    </div>
  );
}
